<template>
  <transition name="slide-menu">
    <section class="c-menu" v-if="menuOpen">
      <header class="c-menu__logo-wrap" v-if="device === 2">
        <my-scroll class="c-menu__logo-link">
          <h1 class="c-menu__logo"><span class="u-hide">UK Power Networks – Delivering your energy</span></h1>
        </my-scroll>
      </header>
      <nav class="c-menu__outer">
        <ul class="c-menu__wrapper">
          <li class="c-menu__item"><my-scroll :is-menu="true" :href="'#ceo-introduction'">CEO’s introduction &amp; our journey</my-scroll></li>
          <li class="c-menu__item"><my-scroll :is-menu="true" :href="'#focus-areas'">Our focus areas</my-scroll></li>
          <li class="c-menu__item"><my-scroll :is-menu="true" :href="'#future-energy'">Future energy landscape</my-scroll></li>
          <li class="c-menu__item"><my-scroll :is-menu="true" :href="'#operations'">Our operations</my-scroll></li>
          <li class="c-menu__item"><my-scroll :is-menu="true" :href="'#vision-values'">Our vision &amp; values</my-scroll></li>
          <li class="c-menu__item"><my-scroll :is-menu="true" :href="'#people'">Our people</my-scroll></li>
          <li class="c-menu__item"><my-scroll :is-menu="true" :href="'#governance'">Governance</my-scroll></li>
          <li class="c-menu__item"><my-scroll :is-menu="true" :href="'#financial-performance'">Our financial performance</my-scroll></li>
          <li class="c-menu__item"><my-scroll :is-menu="true" :href="'#uk-power-network-services'">UK Power Networks Services</my-scroll></li>
          <li class="c-menu__item"><a @click.prevent="openDownload" href="#download" class="c-menu__link c-menu__link--tinted">
            <span class="o-link--icon"><span class="o-link--icon__text">Downloads</span><svg class="icon icon-download o-link--icon__icon"><use xlink:href="#icon-download"></use></svg></span>
          </a></li>
        </ul>
      </nav>
    </section>
  </transition>
</template>

<script>
import MyScroll from '@/components/standard/my-scroll'
// import { IconDownload } from '@/components/standard/my-icons'

export default {
  name: 'my-menu',
  components: {
    MyScroll
    // IconDownload
  },
  computed: {
    device () {
      return this.$store.state.device
    },
    menuOpen () {
      return this.$store.state.menuOpen
    }
  },
  methods: {
    openDownload () {
      this.$store.commit('setDownload', true)
    }
  },
  created () {
    this.$store.commit('setMenu', this.device === 2)
  },
  watch: {
    device (val) {
      const bool = val === 2
      this.$store.commit('setMenu', bool)
    }
  }
}
</script>



// WEBPACK FOOTER //
// MyMenu.vue?6a259230